import React from 'react'

export const GoogleChannelForm = ({ dataItem, onChange }) => {
    return (
        <>

            <div className='col-6 mt-2'>
                <label htmlFor="customer_id">Customer ID *</label>
                <input
                    type="text"
                    name="customer_id"
                    className='form-control form-control-sm'
                    placeholder="Enter Customer ID"
                    value={dataItem.customer_id}
                    onChange={onChange}
                />
            </div>
            <div className='col-6 mt-2'>
                <label htmlFor="client_id">Client ID *</label>
                <input
                    type="password"
                    name="client_id"
                    placeholder="Enter Client ID"
                    className='form-control form-control-sm'
                    value={dataItem.client_id}
                    onChange={onChange}
                />
            </div>
            <div className='col-6 mt-2'>
                <label htmlFor="client_secret">Client Secret *</label>
                <input
                    type="password"
                    name="client_secret"
                    className='form-control form-control-sm'
                    placeholder="Enter Client Secret"
                    value={dataItem.client_secret}
                    onChange={onChange}
                />
            </div>
            <div className='col-6 mt-2'>
                <label htmlFor="developer_token">Developer Token *</label>
                <input
                    type="password"
                    name="developer_token"
                    className='form-control form-control-sm'
                    placeholder="Enter Developer Token"
                    value={dataItem.developer_token}
                    onChange={onChange}
                />
            </div>
            <div className='col-6 mt-2'>
                <label htmlFor="scope">Scope *</label>
                <input
                    type="text"
                    name="scope"
                    className='form-control form-control-sm'
                    placeholder="Enter Scope"
                    value={dataItem.scope}
                    onChange={onChange}
                />
            </div>
            <div className='col-6 mt-2'>
                <label htmlFor="refresh_token">Refresh Token</label>
                <input
                    type="password"
                    name="refresh_token"
                    className='form-control form-control-sm'
                    placeholder="Enter Refresh Token"
                    value={dataItem.refresh_token}
                    onChange={onChange}
                />
            </div>
            <div className="col-12 mt-3">
                <label className="fw-bold">How to get your Google Ads API credentials:</label>
                <div className='row p-2 border rounded overflow-auto' style={{ maxHeight: '250px' }}>
                    <div className="col-6">
                        <ol className="small mt-2">
                            <li>
                                <strong>Customer ID:</strong>
                                <ul>
                                    <li>Go to <a href="https://ads.google.com/" target="_blank" rel="noreferrer">Google Ads</a> and log in.</li>
                                    <li>Your Customer ID is shown at the top of the dashboard in the format: <code>XXX-XXX-XXXX</code>.</li>
                                </ul>
                            </li>
                            <li className="mt-2">
                                <strong>Client ID & Client Secret:</strong>
                                <ul>
                                    <li>Go to the <a href="https://console.cloud.google.com/apis/credentials" target="_blank" rel="noreferrer">Google Cloud Console</a>.</li>
                                    <li>Create a new project or select an existing one.</li>
                                    <li>Navigate to "APIs & Services" &gt; "Credentials".</li>
                                    <li>Click "Create Credentials" &gt; "OAuth 2.0 Client ID".</li>
                                    <li>Set application type to "Web application" and configure authorized redirect URIs.</li>
                                    <li>After creation, you'll get the Client ID and Client Secret.</li>
                                </ul>
                            </li>
                        </ol>
                    </div>
                    <div className="col-6">
                        <ol start="3" className="small mt-2">
                            <li>
                                <strong>Developer Token:</strong>
                                <ul>
                                    <li>Go to your <a href="https://ads.google.com/" target="_blank" rel="noreferrer">Google Ads account</a>.</li>
                                    <li>Click on "Tools & Settings" &gt; "Setup" &gt; "API Center".</li>
                                    <li>Request a Developer Token. Approval may take time.</li>
                                    <li>Once approved, copy the Developer Token for use.</li>
                                </ul>
                            </li>
                            <li className="mt-2">
                                <strong>Scope:</strong>
                                <ul>
                                    <li>Use: <code>https://www.googleapis.com/auth/adwords</code></li>
                                </ul>
                            </li>
                            <li className="mt-2">
                                <strong>Refresh Token:</strong>
                                <ul>
                                    <li>Use the OAuth 2.0 flow to authorize your app and retrieve the refresh token.</li>
                                    <li>You can follow the steps in the <a href="https://developers.google.com/google-ads/api/docs/oauth/cloud-project" target="_blank" rel="noreferrer">Google Ads API OAuth documentation</a>.</li>
                                    <li>Tools like Postman or Google's OAuth Playground can help you obtain it.</li>
                                </ul>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </>
    )
}
